import { displayNumber } from 'utils/misc';

type Props = {
  value: number;
};
export default function HoursDisplay(props: Props) {
  return (
    <div style={{ textAlign: 'right' }}>{displayNumber(props.value, 2)}</div>
  );
}
